import { FC } from 'react'

import { useGET_groupCoursesQuery } from 'redux/api/groupCoursesApi'

import PageHeading from 'components/atoms/PageHeading'
import MainTable from 'components/organisms/tables/MainTable'
import GroupEnrollCourseForm from 'components/organisms/forms/GroupEnrollCourseForm'

import { useTableModel } from 'utils/tableModels/useGroupEnrolledCoursesTableModel'

import { useTranslation } from 'react-i18next'
import { ActionType } from 'types'
import { Grid } from '@mui/material'
import { removeEmpty } from 'utils/helpers'


interface IProps {
    action: ActionType
    id: string
    viewOnly: boolean
    tabText?: string
    tabKey?: string
  }

  
const GroupEnrolledCourses: FC<IProps> = ({ action, id, viewOnly }) => {
  const { t } = useTranslation()
  const filters = {
    group: id,
  }

  return (
    <>
      <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
        <Grid item xs={6}>
          <PageHeading title={t('common.enrolled-courses')} />
        </Grid>
        <Grid item xs={6}>
          <GroupEnrollCourseForm action={action} id={id} viewOnly={viewOnly} />
        </Grid>
      </Grid>

      <MainTable
        useTableModel={useTableModel}
        getTableData={useGET_groupCoursesQuery}
        tableRowParams={ {group_id: id} }
        filters={removeEmpty(filters)}
        header={null}
      />
    </>
  )
}
export default GroupEnrolledCourses